import { render, staticRenderFns } from "./TechnologyPlatform.vue?vue&type=template&id=8aef7da8&scoped=true"
import script from "./TechnologyPlatform.vue?vue&type=script&lang=js"
export * from "./TechnologyPlatform.vue?vue&type=script&lang=js"
import style0 from "./TechnologyPlatform.vue?vue&type=style&index=0&id=8aef7da8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8aef7da8",
  null
  
)

export default component.exports